var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "evenodd",
    d: "M7.373 1.342a.627.627 0 0 1 1.255 0V9.56l2.032-2.033a.627.627 0 1 1 .887.888l-3.103 3.103a.63.63 0 0 1-.888 0L4.453 8.414a.627.627 0 1 1 .887-.888L7.373 9.56zm7.298 9.6a.627.627 0 1 1 1.255 0v3.48c0 .347-.281.628-.628.628H.702a.627.627 0 0 1-.627-.627v-3.48a.627.627 0 1 1 1.255 0v2.852h13.34z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "download_svg__mask0_543_4398",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.373 1.342a.627.627 0 0 1 1.255 0V9.56l2.032-2.033a.627.627 0 1 1 .887.888l-3.103 3.103a.63.63 0 0 1-.888 0L4.453 8.414a.627.627 0 1 1 .887-.888L7.373 9.56zm7.298 9.6a.627.627 0 1 1 1.255 0v3.48c0 .347-.281.628-.628.628H.702a.627.627 0 0 1-.627-.627v-3.48a.627.627 0 1 1 1.255 0v2.852h13.34z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#download_svg__mask0_543_4398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }))));
};
export default SvgDownload;